/**
 * Zoom slot component.  @deprecated Zoom is deprecated, please use `<[Chart].Zoom/>`` instead.
 */
export const Zoom = () => null;
/* eslint-disable-next-line @typescript-eslint/no-deprecated */
Zoom['displayName'] = 'Zoom';
